"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVehicleFormActions = void 0;
var EVehicleFormActions;
(function (EVehicleFormActions) {
    EVehicleFormActions["EDIT"] = "EDIT";
})(EVehicleFormActions = exports.EVehicleFormActions || (exports.EVehicleFormActions = {}));
